var StopLocation = require('js/lib/stopLocation');

function DummyStopLocation(features) {
  var customers = [];

  features.forEach(function(feature) {
    feature.get('stop').customers.forEach(function(customer) {
      customers.push(customer);
    });
  });

  this.customers = customers;
}

DummyStopLocation.prototype = Object.create(StopLocation.prototype);
DummyStopLocation.prototype.constructor = DummyStopLocation;

module.exports = DummyStopLocation;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/dummyStopLocation.js
 ** module id = 176
 ** module chunks = 1
 **/